import script from "./returned-signable-documents-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./returned-signable-documents-modal.vue?vue&type=script&setup=true&lang=ts"

import "./returned-signable-documents-modal.vue?vue&type=style&index=0&id=fc5afb62&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc5afb62"]])

export default __exports__